import React from 'react';
import { withRouter } from 'react-router-dom';
import Grid from './Grid.jsx';

class Usuarios extends React.Component {

    constructor() {

        super();

        this.state = {
            gridHeader: [ "Nome", "E-Mail", "Centro", "Status" ],
            usuarios: [],
            centroItens: [],
            centro: "Todos",
            status: "Ativo"
        };

        this.changeCentro = this.changeCentro.bind(this);
        this.changeStatus = this.changeStatus.bind(this);
        this.cadastrarUsuario = this.cadastrarUsuario.bind(this);

    }

    changeCentro(e) {

        this.setState({ centro: e.target.value });
        let centro = e.target.value;

        if (centro === "Todos") {

            fetch("/api/usuario/grid/" + this.state.status, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                this.setState({ usuarios: [] });
                this.setState({ usuarios: responseJson });

            });

        } else {

            fetch("/api/usuario/grid/" + centro + "/" + this.state.status, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                this.setState({ usuarios: [] });
                this.setState({ usuarios: responseJson });

            });

        }

    }

    changeStatus(e) {

        this.setState({ status: e.target.value });
        let status = e.target.value;

        if (this.state.centro === "Todos") {

            fetch("/api/usuario/grid/" + status, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                this.setState({ usuarios: [] });
                this.setState({ usuarios: responseJson });

            });

        } else {

            fetch("/api/usuario/grid/" + this.state.centro + "/" + status, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                this.setState({ usuarios: [] });
                this.setState({ usuarios: responseJson });

            });

        }

    }

    cadastrarUsuario() {
        this.props.history.push("/cadastrarusuario");
    }

    componentDidMount() {

        if (localStorage.roleUsuarios === "nenhuma") {
            window.location.href = "/home";
        }

        fetch("/api/centro/", {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centroItens: responseJson });

            fetch("/api/usuario/grid/Ativo", {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response2 => response2.json())
            .then(responseJson2 => {

                this.setState({ usuarios: responseJson2 });

            });

        });

    }

    render() {
        return(
            <div>
                <h1 id="usuarios-titulo">Usuários</h1><br />
                <p id="usuarios-txt">
                    Clique em um dos usuários para visualizar suas informações.
                </p><br /><br />
                <form id="usuarios-filtro">
                    <span>Filtrar por centro: </span>
                    <select value={ this.state.centro } onChange={ this.changeCentro }>
                        <option value="Todos">Todos</option>
                        { this.state.centroItens.map((item, i) =>
                            <option key={ i } value={ item.id }>{ item.nome }</option> ) }
                    </select>
                    <span Style={ "margin-left: 30px;" }>
                        Filtrar por status: 
                    </span>
                    <select value={ this.state.status } onChange={ this.changeStatus }>
                        <option value="Ativo">Ativo</option>
                        <option value="Inativo">Inativo</option>
                        <option value="Todos">Todos</option>
                    </select>
                </form>
                <br /><br />
                <Grid key={ this.state.usuarios }
                    header={ this.state.gridHeader }
                    data={ this.state.usuarios }
                    pageSize={ 10 }
                    gridWidth={ "600px" }
                    linkTo={ "/visualizarusuario" } />
                { localStorage.roleUsuarios === "escrever" &&
                    <button type="button" id="usuarios-cadastrar-btn" onClick={ this.cadastrarUsuario }>
                        Cadastrar Usuário
                    </button> }
            </div>
        );
    }

}

export default withRouter(Usuarios);

